import {gql} from '@apollo/client';

import {Sprinkles} from '#style/sprinkles';

export const checkInCardTestPeriodFragment = gql`
  fragment CheckInCardTestPeriodFragment on TestPeriod {
    checkInStats(input: {includeCurrentCheckIn: true}) {
      completed
      endedOn
      startedOn
    }
    id
    startedAt
  }
`;

export interface CheckInCardProps {
  /**
   * Indicates if the user has an available check-in to complete.
   *
   * @default false
   */
  canCheckIn?: boolean;
  /**
   * The number of `checkIn`s the user has completed for the current
   * `testPeriod`.
   *
   * @default 0
   */
  completedCheckIns?: number;
  /**
   * Indicates if the user has selected an `actionPlan`.
   *
   * @default false
   */
  hasSelectedActionPlan?: boolean;
  /**
   * The maximum number of `checkIn`s the user may have completed for the
   * current `testPeriod`.
   *
   * @default 1
   */
  totalCheckIns?: number;
  columnSpan?: Sprinkles['gridColumnSpan'];
}
